<template>
  <div class="hotel-service" v-if="config">


    <!-- Banner 横幅 -->
    <div class="banner-section">
      <banner
        v-if="config.bannerList && config.bannerList.length > 0"
        :list="config.bannerList"
        :bannerDuration="config.bannerDuration || 3000"
        @slide-click="handleBannerClick">
        <template slot-scope="scope">
          <div class="banner-slide">
            <img class="banner-img" :src="scope.item.imageUrl || scope.item.url || scope.data" alt="banner" />
          </div>
        </template>
      </banner>
      <div v-else class="banner-placeholder">
        <img class="banner-img" src="@/assets/images/hotel/banner-default.png" alt="banner" />
      </div>
    </div>

    <!-- 酒店信息区 -->
    <div class="hotel-info">
      <div class="hotel-info-left">
        <h1 class="hotel-name">{{ config.hotelName }}</h1>
        <p class="hotel-address">{{ config.hotelAddress }}</p>
      </div>
      <div class="hotel-info-right">
        <button class="booking-btn" @click="handleBooking">立即预订</button>
      </div>
    </div>

    <!-- 全部服务标题 -->
    <div class="section-title-wrap">
      <h2 class="section-title">全部服务</h2>
      <img class="section-title-shadow" src="@/assets/images/hotel/section-shadow.png" alt="" />
    </div>

    <!-- 全部服务区 -->
    <div class="service-section">
      <div class="service-grid">
        <div
          class="service-item"
          v-for="(item, index) in serviceList"
          :key="index"
          @click="handleServiceClick(item)">
          <img class="service-icon" :src="item.icon" :alt="item.name" />
        </div>
      </div>
    </div>

    <!-- 联系管家横幅 -->
    <!-- 配置了背景图：只展示背景图 -->
    <div class="butler-banner butler-banner--custom" v-if="config.butlerConfig && config.butlerConfig.backgroundImg" @click="handleButlerClick"
      :style="{ backgroundImage: `url(${config.butlerConfig.backgroundImg})` }">
    </div>
    <!-- 未配置背景图：默认文案+logo+静态背景图 -->
    <div class="butler-banner butler-banner--default" v-else-if="config.butlerConfig" @click="handleButlerClick">
      <div class="butler-left">
        <img class="butler-logo" src="@/assets/images/hotel/butler-logo.png" alt="" />
        <span class="butler-text">{{ config.butlerConfig.title || '联系酒店服务管家' }}</span>
      </div>
      <span class="butler-arrow">&gt;</span>
    </div>

    <!-- 其他服务标题 -->
    <div class="section-title-wrap" v-if="config.otherServiceList && config.otherServiceList.length > 0">
      <h2 class="section-title">其他服务</h2>
      <img class="section-title-shadow" src="@/assets/images/hotel/section-shadow.png" alt="" />
    </div>

    <!-- 其他服务区 -->
    <div class="other-service-section" v-if="config.otherServiceList && config.otherServiceList.length > 0">
      <div class="other-service-grid">
        <div
          class="other-service-card"
          v-for="(item, index) in config.otherServiceList"
          :key="item.serviceId || index"
          @click="handleOtherServiceClick(item)">
          <div class="card-content">
            <div class="card-text">
              <span class="card-title">{{ item.name }}</span>
              <p class="card-desc">{{ item.description }}</p>
            </div>
            <img v-if="item.icon" class="card-icon" :src="item.icon" :alt="item.name" />
          </div>
        </div>
      </div>
    </div>

    <!-- WiFi 弹窗 -->
    <div class="popup-overlay" v-if="showWifiPopup" @click="showWifiPopup = false">
      <div class="wifi-popup" @click.stop>
        <h3>酒店WiFi</h3>
        <div class="wifi-info">
          <p>网络名称：<span class="wifi-value">{{ wifiInfo.ssid }}</span></p>
          <p>密码：<span class="wifi-value">{{ wifiInfo.password }}</span></p>
        </div>
        <button class="copy-btn" @click="copyWifiPassword">复制密码</button>
      </div>
    </div>





    <!-- Toast 提示 -->
    <div class="toast" v-if="toastMessage">{{ toastMessage }}</div>
  </div>
</template>

<script>
import { hotelApi } from '@/api/modules/hotel'
import { commonApi } from '@/api'
import banner from '@/components/swiper.vue'

export default {
  name: 'HotelService',
  components: { banner },
  data() {
    return {
      config: null,
      loading: false,
      showWifiPopup: false,


      toastMessage: '',
      wifiInfo: {
        ssid: 'Hotel-WiFi',
        password: '12345678'
      },
      defaultServices: [
        { name: 'WiFi', icon: require('@/assets/images/hotel/service-1.png'), type: 'wifi' },
        { name: '客房送物', icon: require('@/assets/images/hotel/service-2.png'), type: 'link', actionUrl: '' },
        { name: '打扫卫生', icon: require('@/assets/images/hotel/service-3.png'), type: 'link', actionUrl: '' },
        { name: '洗衣服务', icon: require('@/assets/images/hotel/service-4.png'), type: 'link', actionUrl: '' },
        { name: '更多', icon: require('@/assets/images/hotel/service-5.png'), type: 'link', actionUrl: '' }
      ]
    }
  },
  computed: {
    serviceList() {
      if (this.config && this.config.serviceList && this.config.serviceList.length > 0) {
        return this.config.serviceList.slice(0, 5)
      }
      return this.defaultServices
    }
  },
  created() {
    this.init()
    this.recordOpenTimes()
  },
  methods: {
    async init() {
      this.loading = true
      try {
        const urlParams = this.$route.query
        const result = await hotelApi.getHotelServiceConfig({
          nfcConfig: urlParams.nfcConfig,
          hotelId: urlParams.hotelId,
          channelType: urlParams.jump ? 2 : 1
        })
        this.config = result
        console.log('Hotel config:', result)
      } catch (error) {
        console.error('获取酒店配置失败:', error)
        this.showToast('加载失败，请重试')
      } finally {
        this.loading = false
      }
    },

    // 访问记录上报
    async recordOpenTimes() {
      await this.reportEvent()
    },

// Toast 提示
    showToast(msg) {
      this.toastMessage = msg
      setTimeout(() => {
        this.toastMessage = ''
      }, 2000)
    },

    // 通用上报方法
    async reportEvent(option = {}) {
      const urlParams = this.$route.query
      await commonApi.newRecordOpenTimes({
        ...option,
        channel: urlParams.jump ? 2 : 1,
        merchantId: urlParams.nfcConfig,
        type: urlParams.type || 0
      })
    },

    // Banner 点击
    async handleBannerClick(bannerItem) {
      await this.reportEvent({ merchantChannelId: 10, bannerId: bannerItem.bannerId })
      if (bannerItem.linkUrl) {
        window.location.href = bannerItem.linkUrl
      }
    },

    // 预订点击
    async handleBooking() {
      await this.reportEvent({ merchantChannelId: 20 })
      if (this.config.bookingUrl) {
        window.location.href = this.config.bookingUrl
      } else {
        this.showToast('暂无预订链接')
      }
    },

    // 服务点击
    async handleServiceClick(item) {
      if (item.type === 'wifi') {
        this.handleWifiClick()
        return
      }

      await this.reportEvent({ merchantChannelId: 22 })

      this.navigateByLinkType(item)
    },

    // 根据 linkType 跳转
    navigateByLinkType(item) {
      const linkType = item.linkType || 1
      switch (linkType) {
        case 1: // HTTP链接
          if (item.actionUrl) {
            window.location.href = item.actionUrl
          } else {
            this.showToast('该服务暂未开放')
          }
          break
        case 2: // 微信小程序
          if (item.wxAppId && item.wxPath) {
            const query = item.wxQuery ? encodeURIComponent(item.wxQuery) : ''
            const url = `weixin://dl/business/?appid=${item.wxAppId}&path=${item.wxPath}${query ? '&query=' + query : ''}`
            window.location.href = url
          } else {
            this.showToast('该服务暂未开放')
          }
          break
        case 3: // 抖音
          if (item.dyMerchantId) {
            window.location.href = `snssdk1128://poi/detail?id=${item.dyMerchantId}&&from=webview&refer=web`
          } else {
            this.showToast('该服务暂未开放')
          }
          break
        default:
          this.showToast('该服务暂未开放')
      }
    },

    // WiFi 点击
    handleWifiClick() {
      this.showWifiPopup = true
    },

    // 复制 WiFi 密码
    copyWifiPassword() {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(this.wifiInfo.password)
      }
      this.showToast('密码已复制')
      this.showWifiPopup = false
    },

    // 管家点击
    async handleButlerClick() {
      if (this.config.butlerConfig && this.config.butlerConfig.actionUrl) {
        await this.reportEvent({ merchantChannelId: 18 })
        window.location.href = this.config.butlerConfig.actionUrl
      }
    },

    // 其他服务点击
    async handleOtherServiceClick(item) {
      await this.reportEvent({ merchantChannelId: 24 })
      this.navigateByLinkType(item)
    },


  }
}
</script>

<style lang="scss" scoped>
.hotel-service {
  min-height: 100vh;
  background-color: #F8F8F8;
  padding-bottom: 20px;
}

// Banner
.banner-section {
  height: 225px;

  .banner-slide {
    width: 100%;
    height: 225px;
  }

  .banner-img {
    width: 100%;
    height: 225px;
    object-fit: cover;
  }

  .banner-placeholder {
    width: 100%;
    height: 225px;

    .banner-img {
      width: 100%;
      height: 225px;
      object-fit: cover;
    }
  }
}

// 酒店信息（卡片式，上移遮挡轮播图底部）
.hotel-info {
  background: linear-gradient(90deg, #F7F5FC 0%, #F0FBFD 100%);
  padding: 12px 16px;
  margin-top: -20px;
  position: relative;
  z-index: 2;
  border-radius: 30px 0 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &::before {
    content: '';
    position: absolute;
    bottom: 100%;
    right: 0;
    width: 55px;
    height: 43px;
    background: url('~@/assets/images/hotel/hotel-info-decor.png') no-repeat;
    background-size: 100% 100%;
    pointer-events: none;
    z-index: 3;
  }

  .hotel-info-left {
    flex: 1;

    .hotel-name {
      font-family: PingFang SC, PingFang SC;
      font-weight: bold;
      font-size: 20px;
      color: #000000;
      text-align: left;
      margin: 0 0 2px 0;
    }

    .hotel-address {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.8);
      text-align: left;
      margin: 0;
    }
  }

  .booking-btn {
    background: #232773;
    color: #fff;
    border: none;
    border-radius: 8px;
    padding: 8px 16px;
    font-size: 14px;
    cursor: pointer;

    &:active {
      opacity: 0.8;
    }
  }
}

// 全部服务标题
.section-title-wrap {
  padding: 16px 0 0;
  position: relative;
  display: inline-block;
  margin-left: 12px;

  .section-title {
    font-size: 17px;
    font-weight: bold;
    color: #000;
    margin: 0;
    position: relative;
    z-index: 1;
  }

  .section-title-shadow {
    display: block;
    width: 70px;
    height: 8px;
    margin-top: -8px;
    position: relative;
    z-index: 0;
  }
}

// 服务区块
.service-section {
  background: #fff;
  padding: 5px 4px;
  margin: 12px 12px 0;
  border-radius: 4px;

  .service-grid {
    display: flex;
    justify-content: space-evenly;
    padding-bottom: 8px;

    .service-item {
      flex-shrink: 0;
      width: 20%;
      display: flex;
      flex-direction: column;
      align-items: center;

      .service-icon {
        width: 100%;
        height: auto;
      }
    }
  }
}

// 管家横幅
.butler-banner {
  margin: 12px 12px;
  border-radius: 4px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: space-between;

  // 配置了背景图：只展示背景图
  &--custom {
    height: 110px;
  }

  // 未配置背景图：默认方案
  &--default {
    height: 44px;
    background-image: url('~@/assets/images/hotel/butler-bg.png');
    padding: 0 16px;
  }

  .butler-left {
    display: flex;
    align-items: center;

    .butler-logo {
      width: 28px;
      height: 28px;
      margin-right: 8px;
    }

    .butler-text {
      font-size: 15px;
      font-weight: bold;
      color: #fff;
    }
  }

  .butler-arrow {
    color: #fff;
    font-size: 16px;
  }
}

// 其他服务
.other-service-section {
  padding: 12px 12px 0;
  margin: 0;

  .other-service-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;

    .other-service-card {
      background: #fff;
      border-radius: 4px;
      height: 78px;
      padding: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

      .card-content {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        height: 100%;
      }

      .card-text {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;

        .card-title {
          font-size: 14px;
          font-weight: bold;
          color: #000;
          display: block;
          margin-bottom: 2px;
        }

        .card-desc {
          font-size: 10px;
          color: #999;
          margin: 0;
        }
      }

      .card-icon {
        width: 24px;
        height: 24px;
        margin-left: 4px;
        flex-shrink: 0;
      }
    }
  }
}

// 弹窗遮罩
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: flex-end;
  justify-content: center;
  z-index: 1000;
}

// WiFi 弹窗
.wifi-popup {
  width: 100%;
  background: #fff;
  border-radius: 16px 16px 0 0;
  padding: 20px;
  text-align: center;

  h3 {
    font-size: 16px;
    color: #000;
    margin: 0 0 20px 0;
  }

  .wifi-info {
    text-align: left;
    background: #f5f5f5;
    padding: 16px;
    border-radius: 8px;
    margin-bottom: 20px;

    p {
      margin: 8px 0;
      font-size: 14px;
      color: #333;
    }

    .wifi-value {
      color: #4169E1;
      font-weight: bold;
    }
  }

  .copy-btn {
    width: 100%;
    height: 44px;
    background: #4169E1;
    color: #fff;
    border: none;
    border-radius: 8px;
    font-size: 14px;
  }
}

// 更多服务弹窗
.more-services-popup {
  width: 100%;
  max-height: 60vh;
  background: #fff;
  border-radius: 16px 16px 0 0;
  padding: 20px;

  h3 {
    font-size: 16px;
    color: #000;
    margin: 0 0 20px 0;
    text-align: center;
  }

  .more-service-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;

    .service-item {
      display: flex;
      flex-direction: column;
      align-items: center;

      .service-icon {
        width: 48px;
        height: 48px;
        margin-bottom: 8px;
      }

      .service-name {
        font-size: 12px;
        color: #666;
      }
    }
  }
}

// Toast 提示
.toast {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  z-index: 2000;
}
</style>
